import { Users } from 'lucide-react';

/** Sélecteur « Commercial » — options issues de useNr2jOwnerFilter. */
export default function Nr2jOwnerFilterSelect({ value, onChange, options = [], className = '' }) {
  if (!options.length) return null;
  const ungrouped = options.filter((o) => !o.group);
  const groups = [];
  for (const option of options) {
    if (!option.group) continue;
    let group = groups.find((g) => g.label === option.group);
    if (!group) {
      group = { label: option.group, options: [] };
      groups.push(group);
    }
    group.options.push(option);
  }
  const known = options.some((o) => o.value === value);

  return (
    <label className={`relative inline-flex items-center ${className}`}>
      <span className="sr-only">Commercial</span>
      <Users className="pointer-events-none absolute left-3 h-4 w-4 text-gray-400" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-lg border border-gray-300 bg-white py-2 pl-9 pr-8 text-sm"
        data-testid="nr2j-owner-filter"
      >
        {!known && value ? <option value={value}>Commercial sélectionné</option> : null}
        {ungrouped.map((o) => (
          <option key={o.value || 'all'} value={o.value}>{o.label}</option>
        ))}
        {groups.map((g) => (
          <optgroup key={g.label} label={g.label}>
            {g.options.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </optgroup>
        ))}
      </select>
    </label>
  );
}
